import { Controller } from 'stimulus';

class DropdownController extends Controller {
  static targets = ['panel'];

  initialize() {
    this.isOpen = false;
    this._setWindowListener();
  }

  toggle(event = null) {
    if (event) {
      event.stopPropagation();
    }

    this.panelTargets.forEach((el) => {
      el.classList.toggle('u-displayNone');
    });
    this.isOpen = !this.isOpen;
  }

  _listener(e) {
    if (this.isOpen && !e.target.closest('[data-controller~="dropdown"]')) {
      this.toggle();
    }
  }

  _setWindowListener() {
    window.addEventListener('click', this._listener.bind(this));
  }
}

export default DropdownController;
